import cn from 'classnames';
import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { LinkButton } from 'app/blocks/buttons/buttons';

import { isStatic } from 'app/route/history';

type LinkButtonOrLinkProps = {
    className?: string;
    href: string;
    explicitHref?: boolean;
} & Omit<LinkProps, 'to'>;

const LinkButtonOrLink: React.FC<LinkButtonOrLinkProps> = ({ className = '', href, ...props }) => {
    return isStatic() ? (
        <LinkButton className={className} href={href} {...props} isLinkTag />
    ) : (
        <Link className={cn(className)} to={href} {...props} />
    );
};

export default LinkButtonOrLink;
